<template>
    <OpenAILogsTabs tab-key="total-per-team" class="py-12">
        <DataTable
            class="mt-10"
            :headers="headers"
            :items="logs"
            title="Open AI logs - total per team"
            searchable
            date-input
        >
            <template #item-custom="{ row }">
                <inertia-link
                    :href="route('kiosk.open-ai.user-per-team.index', { team: row.team_id as number })"
                    class="p-6 text-gray-500 hover:text-blue-500"
                >
                    <AtomicButton size="sm" color="white">
                        <template #icon>
                            <MagnifyingGlassIcon
                                class="h-6 w-6 transition duration-200 group-hover:text-gray-600"
                            />
                        </template>
                    </AtomicButton>
                </inertia-link>
            </template>
        </DataTable>
    </OpenAILogsTabs>
</template>

<script lang="ts" setup>
import IPaginationData from '@/components/Atomic/DataTable/types/IPaginationData';
import IDataTableHeader from '@/components/Atomic/DataTable/types/IDataTableHeader';
import IOpenAILog from '@/types/OpenAILogs/IOpenAILog';
import { route } from 'ziggy-js';
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline';

defineProps<{
    logs: IPaginationData<IOpenAILog>;
}>();

const headers: IDataTableHeader[] = [
    {
        text: 'Team ID',
        id: 'team_id',
        sortable: true,
        sortableId: 'team_id',
    },
    {
        text: 'Team name',
        id: 'name',
        sortable: true,
        sortableId: 'name',
    },
    {
        text: 'Total tokens',
        id: 'total_tokens',
        sortable: true,
        sortableId: 'total_tokens',
    },
    { text: '', id: 'custom' },
];
</script>
